import styled from 'styled-components';
import { Button } from '@veneer/core';
import { primitives } from '@veneer/primitives';
const { color, typography, layout } = primitives;

export const PrinterTitle = styled.p`
  font-family: ${typography.family0};
  font-weight: ${typography.weight4};
  font-size: ${typography.size4};
  line-height: ${typography.lineHeight3};
  color: ${color.gray7};
  margin-bottom: ${typography.size0};
`;
export const PrinterMainTitle = styled.h2`
  font-family: ${typography.family0};
  font-weight: ${typography.weight4};
  font-size: ${typography.size7};
  line-height: ${typography.lineHeight5};
  color: ${color.black};
  margin: ${layout.size3}px 0px;
`;

export const PrinterDescription = styled.p`
  font-family: ${typography.family0};

  font-weight: ${typography.weight3};
  font-size: ${typography.size2};
  line-height: ${typography.lineHeight2};
  color: ${color.gray9};
  margin-bottom: ${typography.size4};
`;
export const PrinterQuickLink = styled.a`
  font-family: ${typography.family0};

  font-weight: ${typography.weight3};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  align-items: center;
  text-decoration-line: underline;
  color: ${color.electricBlue7};
  margin-bottom: ${typography.size4};
`;
export const PrinterCommitmentDetails = styled.p`
  font-family: ${typography.family0};

  font-weight: ${typography.weight3};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  color: #666666;
  margin-top: ${typography.size4};
  margin-bottom: 6px;
`;
export const PrinterTotalPermonth = styled.p`
  font-family: ${typography.family0};

  font-weight: ${typography.weight4};
  font-size: ${typography.size4};
  line-height: ${typography.lineHeight4};
  color: ${color.black};
  margin-bottom: 4px;
`;
export const PrinterPagesPerMonth = styled.p`
  font-family: ${typography.family0};

  font-weight: ${typography.weight3};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
  color: ${color.gray9};
  margin-bottom: ${typography.size4};
  align-self: flex-start;
  display: flex;
  align-items: center;
`;

export const PrinterCurrentPlan = styled.div`
  padding: 8px;
  background: ${color.electricBlue0};
  border-radius: 8px;
  margin-bottom: ${typography.size5};
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  div {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
  span {
    font-weight: ${typography.weight6};
    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};
  }
`;
export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const PrinterButton = styled(Button)`
  width: 49%;
  height: 48px;
`;
export const PrinterThanksButton = styled(Button)`
  width: 49%;
  height: 48px;
`;
export const CheckmarkText = styled.span`
  margin-left: 4px;
`;
export const PrinterDivider = styled.hr`
  border: 1px solid #e0e0e0;
`;
export const ImageContainer = styled.div`
  img {
    width: 20px;
    height: 20px;
  }
`;
